import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetPlanStreaks = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.PLAN_STREAKS],
    staleTime: QueryStaleTime.SHORT,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await PlansService.getPlanStreaksApiV1PlansStreaksGet(user.id);
      return data;
    },
  });

  return { planStreaks: data, isLoading, isError, error, refetch };
};
